import React, { useState, useEffect, useContext, useRef   } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/TopUp.css';
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/member/topupValidate';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext } from "../../../App";
import { useReactToPrint } from 'react-to-print';
import '../../../css/MemberBill.css';

axios.defaults.baseURL = API;

class ComponentToPrint extends React.PureComponent {
    render() {
        function currencyFormat(num) {
            if (num !== "") {
                return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        }
        const billDetails = this.props.BillDetails;
        const productList = this.props.TemProductList;
        const today = Date.now();
        const dateNow = (new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(today));
        return (
            <div className="BillContent">
                <div className="BillHeader">
                    <div className="BillTitle">
                        <span>Manee Cafe</span>
                    </div>
                    <div className="BillTitle">
                          <h4>Top Up Member</h4>
                      </div>
                    <div className="Cashier">
                        <span>Cashier: {billDetails.cashier}</span>
                    </div>
                    <div className="ShowDate">
                        <span>Date: {dateNow}</span>
                    </div>
                    <div className="LocationName">
                        <span>Location: {billDetails.LocationName}</span>
                    </div>
                </div>
                <div className="footer-line"></div>
                <div className="footer-line"></div>
                <div className="BillDetail">
                    <div className="MemberNO">
                        <span>Card Number:</span>
                        <strong>{billDetails.MemberNO}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>Previous Amount:</span>
                        <strong>{currencyFormat(billDetails.PreviousAmount)}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>Top Up Amount:</span>
                        <strong>{currencyFormat(billDetails.TopUpAmount)}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>NetTotal:</span>
                        <strong>{currencyFormat(billDetails.SubTotal)}</strong>
                    </div>
                    <div className="footer-line"></div>
                    <div className="footer-line"></div>
                    <div className="paymentType">
                        <span>PaymentType:</span>
                        <strong>{billDetails.PaymentType}</strong>
                    </div>
                   
                    <div className="paidAmount">
                        <span>PaidAmount:</span>
                        <strong>{currencyFormat(billDetails.PaidAmount)}</strong>
                    </div>
                  
                    <div className="changeAmount">
                        <span>Change:</span>
                        <strong>{currencyFormat(billDetails.ChangeAmount)}</strong>
                    </div>
                    <div className="footer-line"></div>
                    {/* <span>----------------------------------------------------------------------</span> */}
                    <div className="Thankyou">
                        <span>Thank you!</span>
                    </div>
                </div>
            </div>
        );
    }
  }

function TopUp() {
  const componentRef = useRef();
  const {userID, userName, LocationName} = useContext(UserContext);
  const [PaymentTypeList, setPaymentTypeList] = useState([]);
  const [PaymentTypeID, setPaymentTypeID] = useState(0);


  function currencyFormat(num) {
    if (num > 0) 
        return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return 0
  }
 
  const handleSearchMember = e => {
    const { name, value } = e.target;
    handleChange(name, value);
    if(value){
        SearchMember(value);
    } else {

    }
  }

  async function SearchMember(memberNO) {
    let token = localStorage.getItem("token");
    var data = {
        MemberNO: memberNO
    }
    await axios.post("/searchMember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let memberData = response?.data;
        if(memberData.length > 0){
            handleChange("MemberID", memberData[0].MemberID);
            handleChange("Name", memberData[0].FirstName + ' ' + memberData[0].LastName);
            handleChange("PreviousAmount", memberData[0].Amount );
        } else {
            handleChange("MemberID", "");
            handleChange("Name", "");
            handleChange("PreviousAmount", "0" );
            handleChange("TopUpAmount", "0" );
            handleChange("PaidAmount", "0" );
            handleChange("SubTotal", "0" );
        }

    }).catch((err) => {
        console.log(err);
        handleChange("MemberID", "");
        handleChange("Name", "");
        handleChange("PreviousAmount", "0" );
        handleChange("TopUpAmount", "0" );
        handleChange("PaidAmount", "0" );
        handleChange("SubTotal", "0" );
    });
};
  const handleTopUpAmount = (e) => {
    const { name, value } = e.target;
      const re = /^[0-9\b]+$/;
      if (value) {
          if (value === '' || re.test(value.split(',').join(''))) {
            if(Number(value.split(',').join('')) <= 5000000){
              handleChange(name, value.split(',').join(''));
              const subTotal = Number(value.split(',').join('')) + Number(values.PreviousAmount);
              handleChange("SubTotal", subTotal);
            } else {
              handleChange(name, 0);
              handleChange("SubTotal", 0);
            }
          }  
      } else {
          handleChange("SubTotal", 0);
          handleChange(name, 0);
      }
  }

  const handlePaidAmount = event => {
    const { name, value } = event.target;
      const re = /^[0-9\b]+$/;
      if (value) {
          if (value === '' || re.test(value.split(',').join(''))) {
              handleChange(name, value.split(',').join(''));
              const change = Number(value.split(',').join('')) - Number(values.TopUpAmount.split(',').join(''));
              handleChange("ChangeAmount", change);
          }  
      } else {
          handleChange(name, value);
          handleChange("ChangeAmount", 0);
      }
  }

  const handleSelectPaymentType = (e) => {
    var data = PaymentTypeList.filter(function (item) {
        return item.PaymentType === e.target.value
    })
    if (data.length > 0) {
        setPaymentTypeID(data[0].PaymentTypeID);
        handleChange("PaymentType", data[0].PaymentType);
        handleChange("PaymentTypeID", data[0].PaymentTypeID);
    } else {
        handleChange("PaymentType", "");
        handleChange("PaymentTypeID", "");
    }
};

async function saveTutorial() {
    let token = localStorage.getItem("token");
    var data = {
        MemberID: values.MemberID,
        PaymentTypeID: values.PaymentTypeID,
        TopUpAmount: values.TopUpAmount,
        PreviousAmount: values.PreviousAmount,
        SubTotal: values.SubTotal,
        CreateByID: userID,
        CreateDate: new Date(),
        StatusID: 1,
    }
    await axios.post("/topupmember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        handlePrint();
        ClearData();
    }).catch((err) => {
        console.log(err);
    });
};

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
});

const ClearData = () => {
    handleChange("MemberNO", "");
    handleChange("MemberID", "");
    handleChange("MemberID", "");
    handleChange("Name", "");
    handleChange("PreviousAmount", "0" );
    handleChange("TopUpAmount", "0" );
    handleChange("PaidAmount", "0" );
    handleChange("SubTotal", "0" );
}

const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useForm(saveTutorial, validate);

  useEffect(() => {

    let paymentData = localStorage.getItem("paymentTypeData");
    if (paymentData) {
      let userRole = JSON.parse(paymentData);
      setPaymentTypeList(userRole);
    }

  }, []);

  return (
    <div className="TopUpFormContent">
        <form onSubmit={handleSubmit} noValidate className="form">
            <div className="leftContent">
                <div className="leftHeader">
                    <div className="leftTitle">
                        <span>ເຕີມບັດ Member</span>
                    </div>
                </div>
                <div className="leftBody">
                    <div className="txtMemberNo">
                        <span>ເລກບັດ Member</span>
                        <input className={`input form-control ${errors.MemberNO && 'is-invalid'}`} type="text" name="MemberNO" onChange={(e) => handleSearchMember(e)}  value={values.MemberNO || ''} required />
                        {errors.MemberNO && (
                        <p className="invalid-feedback">{errors.MemberNO}</p>
                        )}
                    </div>
                    <div className="txtTopUpAmount">
                        <span>ຍອດເຕີມບັດ</span>
                        <input className={`input form-control ${errors.TopUpAmount && 'is-invalid'}`} type="text" name="TopUpAmount" onChange={(e) => handleTopUpAmount(e)} value={currencyFormat(values.TopUpAmount) || ''} required disabled={!values.Name} />
                        {errors.TopUpAmount && (
                        <p className="invalid-feedback">{errors.TopUpAmount}</p>
                        )}
                    </div>
                    <div className="txtPaidAmount">
                        <span>ຍອດຈ່າຍ</span>
                        <input className={`input form-control ${errors.PaidAmount && 'is-invalid'}`} type="text" name="PaidAmount" onChange={(e) => handlePaidAmount(e)} value={currencyFormat(values.PaidAmount) || ''} required disabled={!values.TopUpAmount} />
                        {errors.PaidAmount && (
                        <p className="invalid-feedback">{errors.PaidAmount}</p>
                        )}
                    </div>
                    <div className="cbPaymentType">
                        <label>ປະເພດຈ່າຍ: </label>
                        <select name="PaymentTypeID" onChange={(e) => handleSelectPaymentType(e)}
                            className={`input form-control ${errors.PaymentTypeID && 'is-invalid'}`}>
                            <option
                                key={""}
                                value={""}
                            >
                                {'ເລືອກໝວດສິນຄ້າ'}
                            </option>
                            {   PaymentTypeList && PaymentTypeList.map(item => (
                                <option
                                    key={item.PaymentTypeID}
                                    value={item.PaymentType}
                                >
                                    {item.PaymentType}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="rightContent">
                <div className="rightBody">
                <div className="col-md-12 order-md-2 mb-12">
                    <h4 className="d-flex justify-content-between align-items-center mb-3 text-primary">
                        <span className="text">ຂໍ້ມູນບັດ Member</span>
                    </h4>
                    <ul className="list-group mb-3">
                        <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                            <h6 className="my-0">ເລກບັດ:</h6>
                        </div>
                        <span className="text-muted">{values.MemberNO}</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                            <h6 className="my-0">ຊື່ລູກຄ້າ:</h6>
                        </div>
                        <span className="text-muted">{values.Name}</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                            <h6 className="my-0">ຍອດເຫຼືອ:</h6>
                        </div>
                        <span className="text-muted">{currencyFormat(values.PreviousAmount)}</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                            <h6 className="my-0">ຍອດຕື່ມບັດ:</h6>
                        </div>
                        <span className="text-muted">{currencyFormat(values.TopUpAmount)}</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                            <h6 className="my-0">ຍອດລວມ:</h6>
                        </div>
                        <span className="text-muted">{currencyFormat(values.SubTotal)}</span>
                        </li>
                    </ul>
                    <ul className="list-group mb-3">
                        <h4 className="d-flex justify-content-between align-items-center mb-3 text-danger">
                        <span className="text">ຂໍ້ມູນການຈ່າຍ</span>
                        </h4>
                        <li className="list-group-item d-flex justify-content-between">
                        <span>ຍອດຈ່າຍ:</span>
                        <strong>{currencyFormat(values.PaidAmount)}</strong>
                        </li>
                        <li className="list-group-item d-flex justify-content-between">
                        <span>ເງິນທອນ:</span>
                        <strong className="text-danger">{currencyFormat(values.ChangeAmount)}</strong>
                        </li>
                    </ul>
                    </div>
                </div>
                <div className="line"></div>
                <div className="rightFooter">
                    <div className="btnPayment"> 
                        <button type="submit" className="btn btn-outline-primary" >ຈ່າຍເງິນ</button>
                    </div>
                </div>
            </div>
        </form>
        <div style={{display: 'none'}}>
            <ComponentToPrint ref={componentRef}
                BillDetails={{"cashier": userName, 
                "LocationName": LocationName, "MemberNO": values.MemberNO,"TopUpAmount": values.TopUpAmount,
                "PaymentType": values.PaymentType, "PreviousAmount": values.PreviousAmount, "SubTotal": values.SubTotal, 
                "PaidAmount": values.PaidAmount,"ChangeAmount": values.ChangeAmount}} 
            />
        </div>
      </div>
  );
};

export default TopUp;
